import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AreaOfInterest, DTSChart, DTSType } from '@/server/MakeSenseApp-backend'
import { ref, provide, watch } from 'vue'

import { use } from 'echarts/core'
import VChart, { THEME_KEY } from 'vue-echarts'
import {
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  MarkAreaComponent,
  DataZoomComponent,
  LegendComponent
} from 'echarts/components'
import { LineChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import { UniversalTransition } from 'echarts/features'


export default /*@__PURE__*/_defineComponent({
  __name: 'DTSChart',
  props: {
  data: DTSChart,
  isLoading: Boolean,
  areaOfInterest: AreaOfInterest
},
  setup(__props) {

use([
  TooltipComponent,
  GridComponent,
  VisualMapComponent,
  LineChart,
  CanvasRenderer,
  MarkAreaComponent,
  UniversalTransition,
  DataZoomComponent,
  LegendComponent
])

provide(THEME_KEY, 'light')

var props = __props

let option = ref<any>()

let colors = ['#FF5C00', '#A01C00']

let specificDtsTypeColors = {
  [DTSType.ConductorTemperature.toString()]: '#FF5C00',
  [DTSType.FiberTemperature.toString()]: '#A01C00'
}

function getColor(name: string | undefined, index: number) {
  if (name && specificDtsTypeColors[name]) {
    return specificDtsTypeColors[name]
  }

  return colors[index % colors.length]
}

watch(
  () => [props.data],
  () => {
    option.value = {
      animationDuration: 100,
      xAxis: {
        type: 'value',
        name: 'Kilometer Point (KP)',
        nameLocation: 'middle',
        nameGap: 30,
        min: function (value: any) {
          return value.min - 1 < 0 ? 0 : Math.round(value.min - 1)
        },
        max: function (value: any) {
          return Math.round(value.max + 1)
        },
        nameTextStyle: {
          fontSize: 12,
          align: 'center',
          color: 'black',
          fontFamily: 'roboto'
        }
      },
      yAxis: {
        type: 'value',
        name: 'Temperature (°C)',
        nameLocation: 'middle',
        nameGap: 40,
        nameTextStyle: {
          fontSize: 12,
          align: 'center',
          color: 'black',
          fontFamily: 'roboto'
        }
      },
      nameTextStyle: {
        align: 'center'
      },
      dataZoom: [
        {
          type: 'inside'
        }
      ],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: (props.data ? props.data.series : [])?.map((x) => x.name),
        textStyle: {
          fontSize: 14,
          color: 'black',
          fontFamily: 'roboto'
        }
      },
      series: (props.data ? props.data.series : [])?.map((x, i) => {
        return {
          name: x.name,
          data: x.values,
          markArea: props.areaOfInterest
            ? {
                itemStyle: {
                  color: 'rgba(255, 173, 177, 0.4)'
                },
                data: [
                  [
                    {
                      xAxis: props.areaOfInterest.minKP
                    },
                    {
                      xAxis: props.areaOfInterest.maxKP
                    }
                  ]
                ]
              }
            : undefined,
          type: 'line',
          symbol: 'none',
          lineStyle: {
            color: getColor(x.name, i),
            width: 3
          },
          itemStyle: {
            color: getColor(x.name, i)
          }
        }
      })
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VChart), {
    loading: __props.isLoading === true || __props.data === undefined,
    class: "chart",
    option: _unref(option),
    autoresize: ""
  }, null, 8, ["loading", "option"]))
}
}

})